import vue from "../main";

export default function(stringDate) {
  let language = vue.$i18n.locale;
  const date = new Date(stringDate);
  return date.toLocaleString(language, { weekday: "short" });
}
